import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import cx from 'classnames'
import moment from 'moment'
import extract from '../../core/extract'
import Card from '../../core/components/Card'
import {loadWorkflowStream, queryNextStep} from '../actions'
import i18n from '../i18n'
import style from './NextStepCard.less'
import {Button} from 'react-bootstrap'
import Icon from '../../core/components/Icon'
import uuid from 'node-uuid'
import {apiOption, apiResponse, apiUrl} from '../../core/fetchz'
import config from '../../config'
import {enterTicket} from '../../ticket/actions'
import {errorStatus} from '../../core/redux/status'
import {loadCompanyOnly} from '../../company/actions'
import {linkFinder} from '../../core/links'

function durationStatus(duration) {
    if (duration && duration > (12 * 3600 * 1000)) return 'success'
    if (duration && duration > 0) return 'warning'
    if (duration) return 'danger'
    return 'success'
}

class NextStepCard extends Component {
    static propTypes = {
        ticket: PropTypes.object.isRequired
    }

    constructor(props) {
        super(props)

        this.state = {
        }
    }

    fetchWorkflows = (clientCompanyId) => {
        const {dispatch} = this.props
        fetch(config.api.url + '/clientcompanies/' + clientCompanyId, apiOption())
            .then(apiResponse)
            .then(({json}) => {
                const {_links} = json
                if (_links && _links.find(linkFinder('workflows'))) {
                    dispatch(loadWorkflowStream(clientCompanyId))
                }
        })
    }

    componentWillMount() {
        const {dispatch, ticket} = this.props
        dispatch(queryNextStep(ticket.uid))
        this.fetchWorkflows(ticket.linkedEntities.clientCompany.uid)
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.ticket != this.props.ticket) {
            const {dispatch, ticket} = nextProps
            dispatch(queryNextStep(ticket.uid))
            dispatch(loadWorkflowStream(ticket.linkedEntities.clientCompany.uid))
        }

        if (nextProps.nextStep != this.props.nextStep) {
            const {nextStep} = nextProps

            clearInterval(this._interval)
            if (nextStep && nextStep.expectedDate) {
                this._computeExpectedDuration(nextStep.expectedDate)
                this._interval = setInterval(() => this._computeExpectedDuration(nextStep.expectedDate), 60 * 1000)
            } else {
                this.setState({expectedDuration: undefined})
            }
        }
    }

    componentWillUnmount() {
        clearInterval(this._interval)
    }

    _computeExpectedDuration(expectedDate) {
        const expectedDuration = new Date(expectedDate) - new Date()
        this.setState({expectedDuration})
    }

    toggleUpdateWorkflow = () => {
        this.setState({updateWorkflow: !this.state.updateWorkflow})
    }

    updateWorkflow = (e) => {
        const {ticket, dispatch} = this.props
        const {uid} = ticket

        const options = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                commandType: 'ApplyWorkflowToTicket',
                workflowUid: e.target.value
            }
        }

        fetch(apiUrl(`${config.api.event.url}/tickets/${uid}`), apiOption(options))
            .then(apiResponse)
            .then(() => {
                this.setState({updateWorkflow: !this.state.updateWorkflow})
                return enterTicket(dispatch, {id: uid})
            })
            .catch((e) => {
                dispatch(errorStatus(e.message))
            })
    }

    _showWorkflow() {
        const {ticket, workflows} = this.props
        const {updateWorkflow} = this.state

        const {qualification} = ticket
        const {workflowApplied} = qualification || {}

        const matchedWorkflow = workflowApplied && workflows && workflows.length > 0 && workflows.find(w => w.uid === workflowApplied)
        return (
            <div className={style.workflow}>
                {matchedWorkflow &&
                    <span title={matchedWorkflow.label}>{matchedWorkflow.label}</span> ||
                    <span title={"Forcer un workflow"}>Forcer un workflow</span>
                }
                <Button
                    bsStyle='link'
                    onClick={this.toggleUpdateWorkflow}
                    title={'Forcer le workflow'}
                    alt={'Forcer le workflow'}>
                    <Icon icon='pencil' size='xs' />
                </Button>

                {updateWorkflow && (<select onChange={this.updateWorkflow} defaultValue={workflowApplied}>
                    {workflowApplied || <option>choisir un workflow</option>}
                    {workflows.map(w => (<option key={w.uid} value={w.uid}>{w.label}</option>))}
                </select>)}
            </div>
        )

    }

    render() {
        const {dispatch, authenticated, nextStep, ticket, workflows, ...others} = this.props
        const {expectedDuration} = this.state

        return (workflows && workflows.length > 0 && (
            <Card active
                status={durationStatus(expectedDuration)}
                header={(<h3>{i18n.nextStep}</h3>)}
                {...others}>
                <div className={style.default}>
                    <div className={style.container}>
                        {expectedDuration && (
                            <p className={style.expectedDuration}>
                                <span>{moment.duration(expectedDuration).humanize()}</span>
                                <small>{expectedDuration < 0 && i18n.overdue}</small>
                            </p>
                        )}
                        {nextStep && <p className={style.expectedCommand}>{extract(i18n.expectedCommandEnum, nextStep.expectedCommand)}</p>}
                    </div>
                    <p className={style.actors}>
                        {nextStep && nextStep.actors.map((actor, index) => (
                            <span
                                key={index}
                                className={cx({[style.highlight]: actor.toUpperCase() == authenticated.userType.toUpperCase()})}>
                                {extract(i18n.actorEnum, actor)}
                            </span>
                        ))}
                    </p>
                    {this._showWorkflow()}
                </div>
            </Card>) || null
        )
    }
}

NextStepCard = connect((state) => ({
    authenticated: state.user.authenticated,
    nextStep: state.workflow.nextStep,
    workflows: state.workflow.stream
}))(NextStepCard)

export default NextStepCard


// WEBPACK FOOTER //
// ./lib/workflow/components/NextStepCard.js